import {HTTP} from '@/services/HttpServices';
import {
    CommunityCalendarCannedResponses, CommunityCalendarFilterData,
    CommunityEvent,
    CommunityEventResponse,
    CommunityEventResponseStatusDisplayOption,
    CommunityEventSummary
} from '@/community-calendar/CommunityCalendarModel';
import {CancelToken} from 'axios';

const ROOT_URL = '/admin/community-calendars';

export function getCommunityEventSummaries(filterData: CommunityCalendarFilterData, searchText?: string, cancelToken?: CancelToken): Promise<CommunityEventSummary[]> {
    return HTTP.post(`${ROOT_URL}/search?searchText=${searchText || ''}`, filterData, { cancelToken });
}

export function getCommunityEventResponseOptions(token?: string): Promise<CommunityEventResponseStatusDisplayOption[]> {
    return HTTP.get(`${ROOT_URL}/options?token=${token}`);
}

export function getCannedResponses(token?: string): Promise<CommunityCalendarCannedResponses> {
    return HTTP.get(`${ROOT_URL}/canned-responses?token=${token}`);
}

export function getCommunityEventDetails(id: number | string, token?: string): Promise<CommunityEvent> {
    return HTTP.get(`${ROOT_URL}/${id}?token=${token}`);
}

export function updateCommunityEventDetails(communityEvent: CommunityEvent, token?: string): Promise<CommunityEvent> {
    return HTTP.put(`${ROOT_URL}/${communityEvent.id}?token=${token}`, communityEvent);
}

export function postCommunityEventResponse(event: CommunityEventResponse, token?: string): Promise<CommunityEventResponse> {
    return HTTP.post(`${ROOT_URL}/${event.communityEventId}/responses?token=${token}`, event);
}
